module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    ref: "dialog",
    attrs: {
      "title": "微信支付",
      "visible": _vm.payVisible,
      "size": "tiny",
      "modal": false,
      "modal-append-to-body": false
    }
  }, [_c('span', [_vm._v("请扫描下面二维码：")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.qrCode,
      "alt": "支付二维码",
      "width": "260px",
      "height": "260px"
    }
  }), _vm._v(" "), _c('span', {
    slot: "footer"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d95a3d62!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WxPay.vue
// module id = 1062
// module chunks = 40